import React, { useEffect, useRef } from "react";
import { Button, Card, CardBody, Col, Container, Input, Label, Row, Spinner } from "@/Components/ui";
;
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import moment from "moment";
import { API_PRECOUPON, API_PRECOUPON_PRODUCT, API_SEND_TO_ALL_VOUCHER, API_USERS_CRM, getDataFromUrl } from "../../../api";
import { BACKEND_HOST } from "../../../api";
import axios from "axios";
import { postData } from "../../../api";
import { SUBDOMAIN } from "../../../assets/meta/meta";
import UserSelectBox from "../../../Components/Common/UserSelectBox";
import toast, { Toaster } from 'react-hot-toast';
import { dialogService } from "@/utils/dialogService";
const SendReservationCoupon = ({ history }) => {
    const [target, setTarget] = React.useState("user");
    const [userList, setUserList] = React.useState([]);
    const [search, setSearch] = React.useState("");
    const [count, setCount] = React.useState(0);
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [isSending, setIsSending] = React.useState(false);
    const [reservationCouponList, setReservationCouponList] = React.useState([]);
    const abortController = useRef(null);
    const [isSendSMS, setIsSendSMS] = React.useState(false);
    const [hasToReceive, setHasToReceive] = React.useState(false);
    const [isBatch, setIsBatch] = React.useState(false);
    const [selectedPreCoupon, setSelectedPreCoupon] = React.useState(0);
    const [voucherCount, setVoucherCount] = React.useState(1);
    useEffect(() => {
        console.log("selectedUsers", selectedUsers);
    }, [selectedUsers]);
    useEffect(() => {
        if (reservationCouponList.length !== 0) {
            setSelectedPreCoupon(reservationCouponList?.[0]?.id);
        }
    }, [reservationCouponList]);
    useEffect(() => {
        if (abortController.current) {
            abortController.current.abort();
        }
        if (search) {
            abortController.current = new AbortController();
            getDataFromUrl(`${API_USERS_CRM}/?search=${search}`, abortController.current.signal)
                .then((data) => {
                console.log(data);
                setUserList(data.results);
                setCount(data.count);
            })
                .catch((e) => {
                console.log(e);
            });
        }
    }, [search]);
    const handleSelectedPreCoupon = (e) => {
        setSelectedPreCoupon(e.target.value);
        console.log("selectedPreCoupon", e.target.value);
    };
    useEffect(() => {
        getDataFromUrl(API_PRECOUPON_PRODUCT)
            .then((data) => {
            setReservationCouponList(data);
            console.log("sendPro", data);
        })
            .catch((e) => {
            console.log(e);
        });
    }, []);
    const sendToCustomers = async () => {
        if (selectedUsers.length === 0) {
            await dialogService.handleAlert("회원을 선택해주세요.");
            return;
        }
        let users = [];
        selectedUsers.forEach((element) => {
            users.push(element.id);
        });
        let _data = {
            users,
            isSendSMS,
            hasToReceive,
            isBatch,
        };
        _data["precoupon_id"] = selectedPreCoupon;
        _data["count"] = voucherCount;
        postData(`${API_PRECOUPON}/send-coupons/`, _data)
            .then((data) => {
            console.log(data);
            if (data.result == "ok") {
                toast.success("예약권이 성공적으로 발송되었습니다.");
            }
            else {
                toast.error(`예약권 발송에 실패했습니다.`);
            }
        })
            .catch((e) => {
            console.log(e);
            toast.error(`예약권 발송에 실패했습니다. ${e?.message}`);
        });
    };
    const sendToAllCustomers = () => {
        let _data = {
            isSendSMS,
            hasToReceive,
            isBatch,
        };
        _data["precoupon_id"] = selectedPreCoupon;
        _data["count"] = voucherCount;
        postData(API_SEND_TO_ALL_VOUCHER, _data)
            .then((data) => {
            console.log(data);
            if (data.result == "ok") {
                toast.success("예약권이 성공적으로 발송되었습니다.");
            }
            else {
                toast.error(`예약권 발송에 실패했습니다.`);
            }
        })
            .catch((e) => {
            console.log(e);
            toast.error(`예약권 발송에 실패했습니다. ${e?.message}`);
        });
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="예약권 보내기" pageTitle="예약권"/>

          <Row className="g-4 mb-3">
            <div className="col-sm-auto">
              <div>
                <h4 className="card-title mb-0 flex-grow-1">예약권 보내기</h4>
              </div>
            </div>
            <div className="col-sm-3 ms-auto">
              {!isSending ? (<div className="d-flex justify-content-sm-end gap-2">
                  <Button color="success" className="add-btn me-1" onClick={target === "user" ? sendToCustomers : sendToAllCustomers} id="create-btn">
                    보내기
                  </Button>
                </div>) : (<div className="d-flex justify-content-sm-end gap-2">
                  <Spinner color="primary"/>
                </div>)}
            </div>
          </Row>

          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <div className="live-preview">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Input className="form-check-input" type="checkbox" id="hasToReceive" value={hasToReceive} onChange={(e) => setHasToReceive(e.target.checked)}/>
                          <Label htmlFor="hasToReceive" className="form-check-label">
                            사용자 수신 필요
                          </Label>
                        </div>
                        <div className="mb-3">
                          <Input className="form-check-input" type="checkbox" id="isSendSMS" value={isSendSMS} onChange={(e) => setIsSendSMS(e.target.checked)}/>
                          <Label htmlFor="isSendSMS" className="form-check-label">
                            사용자가 알림 허용을 (또는 앱설치를) 안한 경우 문자로 보내기
                          </Label>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="reservationCoupon" className="form-label">
                            예약권 선택
                          </Label>
                          <Input type="select" className="form-control" id="reservationCoupon" placeholder="예약권을 선택해주세요." value={selectedPreCoupon} onChange={handleSelectedPreCoupon}>
                            {reservationCouponList?.map((item, index) => (<option key={index} value={item.id}>
                                {item.name}
                              </option>))}
                          </Input>
                        </div>
                      </Col>
                    </Row>

                    <Row></Row>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="notificationBody" className="form-label">
                            수량
                          </Label>
                          <Input type="text" className="form-control" id="notificationBody" placeholder="수량을 입력하세요" value={voucherCount} onChange={(e) => setVoucherCount(e.target.value)}/>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label htmlFor="notificationTarget" className="form-label">
                            대상
                          </Label>
                          <Input type="select" className="form-control" id="notificationTarget" placeholder="대상을 선택하세요" value={target} onChange={(e) => setTarget(e.target.value)}>
                            <option value="all">지점 전체 회원</option>
                            <option value="user">회원 선택</option>
                          </Input>
                        </div>
                      </Col>
                    </Row>
                    {target === "user" && (<>
                        <Row>
                          <Col md={12}>
                            <UserSelectBox userList={userList} setUserList={setUserList} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} search={search} setSearch={setSearch} count={count} setCount={setCount}/>
                          </Col>
                        </Row>
                      </>)}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Toaster position="top-center"/>

      </div>
    </React.Fragment>);
};
export default SendReservationCoupon;
